const apiBaseUrl: string = process.env.NEXT_PUBLIC_API_BASE_URL || '/api';
export default apiBaseUrl;
